import { render } from "./CompanyReputationRisksCell.vue?vue&type=template&id=67116b8f&ts=true"
import script from "./CompanyReputationRisksCell.vue?vue&type=script&lang=ts"
export * from "./CompanyReputationRisksCell.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__